import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../shared/components/input/FormInput";
import FormDatePicker from "../../../../../../shared/components/datepicker/FormDatePicker";
import FormSelect from "../../../../../../shared/components/select/FormSelect";
import { useTranslation } from "react-i18next";

const CreateObjectiveTrackerForm = ({ onSubmitHandler, clients }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    beginDate: yup
      .date()
      .required(t("objectivesTracker.createForm.fields.beginDate.required")),
    endDate: yup
      .date()
      .required(t("objectivesTracker.createForm.fields.endDate.required")),
    clientId: yup
      .string()
      .required(t("objectivesTracker.createForm.fields.client.required")),
    name: yup
      .string()
      .required(t("objectivesTracker.createForm.fields.name.required")),
  });

  const defaultValues = {
    beginDate: "",
    endDate: "",
    clientId: "",
    name: "",
    goal: 0,
    threshold: 0,
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormDatePicker
            name="beginDate"
            label={t("objectivesTracker.createForm.fields.beginDate.label")}
            required
          />
        </div>
        <div className="w-1/2">
          <FormDatePicker
            name="endDate"
            label={t("objectivesTracker.createForm.fields.endDate.label")}
            required
          />
        </div>
      </div>
      <FormInput
        name="name"
        label={t("objectivesTracker.createForm.fields.name.label")}
        placeholder={t("objectivesTracker.createForm.fields.name.placeholder")}
        required
      />
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormSelect
            name="clientId"
            label={t("objectivesTracker.createForm.fields.client.label")}
            options={clients}
            required
          />
        </div>
        <div className="w-1/2">
          <FormInput
            type="number"
            name="goal"
            label={t("objectivesTracker.createForm.fields.goal.label")}
          />
        </div>
      </div>
    </BaseForm>
  );
};

export default CreateObjectiveTrackerForm;
